module.exports = __webpack_public_path__ + "img/add_a_photo-blue-24dp.1768250c.svg";